import styled from "styled-components"

const Close = styled.button`
  color: ${props => props.theme.colors.grey};
  font-size: 20px;
  position: absolute;
  right: 23px;
  top: 15px;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    font-size: 22px;
    right: 25px;
    top: 28px;
  }

  &:before {
    transition: color 0.3s;
  }

  .no-touchevents &:hover {
    &:before {
      color: ${props => props.theme.colors.primary};
    }
  }
`

const NavButton = styled.button`
  align-items: center;
  color: ${props => props.theme.colors.grey};
  display: flex;
  font-size: 21px;
  font-weight: ${props => props.theme.title.w};
  justify-content: space-between;
  width: 100%;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    cursor: default;
    font-size: 14px;
    pointer-events: none;
  }

  &:before {
    flex-shrink: 0;
    font-size: 18px;
    order: 2;
    padding-right: 4px;
    transform: ${props => (props.open ? `rotate(180deg)` : ``)};

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      display: none;
    }
  }
`

const Nav = styled.nav`  
  padding: 90px 0 50px;
  width: 100%;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
      display: flex;
      flex-wrap: wrap;
      margin: auto;
      padding: 75px 0 50px;
  }

  > div {
    &:not(:first-child) {
      @media only screen and (max-width: calc(${props => props.theme.mq.medium} - 1px)) {
          margin-top: 35px;
        }
    }

    &:nth-child(1),
    &:nth-child(2) {
      @media only screen and (min-width: ${props => props.theme.mq.small}) {
          flex: 0 0 auto;
          width: 100%;
      }

      @media only screen and (min-width: ${props => props.theme.mq.medium}) {
          width: 30%;
      }

      ${NavButton} {
        @media only screen and (min-width: ${props => props.theme.mq.small}) {
          color: ${props => props.theme.colors.primary};
        }
      }
    }

    &:nth-child(3) {
      flex-shrink: 0;
      width: 275px;  

      @media only screen and (max-width: calc(${props => props.theme.mq.small} - 1px)) {
            display: none;
        }

        @media only screen and (max-width: calc(${props => props.theme.mq.medium} - 1px)) and (min-width: ${props =>
  props.theme.mq.small}) {
            margin-top: 100px;
        }

        @media only screen and (min-width: ${props => props.theme.mq.medium}) {
          margin-left: auto;
        }
    }
  }
`

const NavList = styled.ul`
  margin-top: 20px;

  @media only screen and (max-width: calc(${props => props.theme.mq.small} - 1px)) {
            display: ${props => (props.open ? `block` : `none`)};
        }

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    margin-top: 35px;
  }

  @media only screen and (max-width: calc(${props => props.theme.mq.medium} - 1px)) and (min-width: ${props =>
  props.theme.mq.small}) {
            display: flex;
            flex-wrap: wrap;
            margin-left: -10px;
            margin-right: -10px;
        }
`

const NavItem = styled.li`
@media only screen and (max-width: calc(${props => props.theme.mq.medium} - 1px)) and (min-width: ${props =>
  props.theme.mq.small}) {
            flex: 0 0 auto;
            padding: 0 10px;
            width: calc(100%/3);
        }

  &:not(:last-child) {
    margin-bottom: 15px;

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      margin-bottom: 20px;
    }

    @media only screen and (min-width: ${props => props.theme.mq.medium}) {
      margin-bottom: 25px;
    }
  }

  a {
    font-size: 16px;
    transition: color 0.3s;

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      font-size: 18px;
    }

    .no-touchevents &:hover, &.active {
      color: ${props => props.theme.colors.primary};
    }
  }
`

const Hot = styled.div`
  margin-top: 20px;
`

const HotImage = styled.div`
  height: 0;
  overflow: hidden;
  padding-bottom: 56.25%;
  width: 100%;

  > div {
    height: 100%;
    transition: transform 1s;

    .no-touchevents a:hover & {
      transform: scale(1.05);
    }
  }
`

const HotCaption = styled.div`
  padding-top: 17px;

  span {
    color: ${props => props.theme.colors.primary};
    display: block;
    font-size: 10px;
    font-weight: ${props => props.theme.title.w};
    letter-spacing: 0.55px;
    margin-bottom: 10px;
    text-transform: uppercase;
  }

  strong {
    display: block;
    font-size: 21px;
    font-weight: ${props => props.theme.title.w};
    line-height: ${props => props.theme.title.lhd};
    margin-bottom: 10px;
    transition: color 0.3s;

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      font-size: 16px;
    }

    .no-touchevents a:hover & {
      color: ${props => props.theme.colors.primary};
    }
  }

  p {
    font-size: 14px;
    font-weight: ${props => props.theme.text.w};
    letter-spacing: 0.3px;
    line-height: ${props => props.theme.text.lhm};
    margin: 0;

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      line-height: ${props => props.theme.text.lhd};
    }
  }
`

const Social = styled.div`
  align-items: center;
  display: flex;
  margin-top: auto;
  margin-bottom: 30px;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    display: none;
  }

  > a {
    &:not(:last-child) {
      margin-right: 20px;
    }
  }
`

const Site = styled.a`
  font-size: 15px;
  font-weight: ${props => props.theme.title.w};
  padding-bottom: 30px;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    display: none;
  }
`

const Wrapper = styled.div`
  background-color: #fff;
  backface-visibility: ${props => (props.open ? `visible` : `hidden`)};
  height: calc(${props => props.theme.units.vh}px * 100);
  left: 0;
  opacity: ${props => (props.open ? `1` : `0`)};
  overflow-y: auto;
  position: fixed;
  top: 0;
  transition-delay: ${props => (props.open ? `0s` : `.7s`)};
  transition-duration: 0.5s;
  transition-property: visibility, opacity, z-index;
  visibility: ${props => (props.open ? `visible` : `hidden`)};
  width: 100%;
  z-index: ${props => (props.open ? `10` : `-10`)};
/* 
  @media only screen and (max-width: calc(${props => props.theme.mq.medium} - 1px)) {
           padding-left: 50px;
           padding-right: 50px;
        } */

  > div {
    display: flex;
    height: 100%;
    position: relative;

    @media only screen and (max-width: calc(${props => props.theme.mq.small} - 1px)) {
           flex-direction: column;
        }
  }

  ${Close} {
    opacity: ${props => (props.open ? `1` : `0`)};
    transition-delay: ${props => (props.open ? `.5s` : `.1s`)};
    transition-duration: 0.5s;
    transition-property: opacity;
  }

  ${Nav} {
    > div {
      opacity: ${props => (props.open ? `1` : `0`)};
      transform: ${props => (props.open ? `translateY(0)` : `translateY(25px)`)};
      transition-duration: 0.5s;
      transition-property: opacity, transform;

      @media only screen and (min-width: ${props => props.theme.mq.small}) {
        transform: ${props => (props.open ? `translateY(0)` : `translateY(50px)`)};
      }

      &:nth-child(1) {
        transition-delay: ${props => (props.open ? `.3s` : `.3s`)};
      }

      &:nth-child(2) {
        transition-delay: ${props => (props.open ? `.4s` : `.2s`)};
      }

      &:nth-child(3) {
        transition-delay: ${props => (props.open ? `.5s` : `.1s`)};
      }
    }
  }

  ${Social}, ${Site} {
    opacity: ${props => (props.open ? `1` : `0`)};
    transition-delay: ${props => (props.open ? `.5s` : `.1s`)};
    transition-duration: 0.5s;
    transition-property: opacity;
  }
`

export const sMenu = {
  Wrapper,
  Close,
  Nav,
  NavButton,
  NavList,
  NavItem,
  Hot,
  HotImage,
  HotCaption,
  Social,
  Site,
}
